import React, { useState,useEffect } from 'react'
import {exportYj01,exportYj02,exportYj03,exportYj04,getUpdatetime} from '../../api/index'
import $message from '../../ui/messge'
import { Result,UpdateTimes } from '../../interface'
import { LongDateFormat, ResultEnum } from '../../enums'
import moment from 'moment'
import './index.less'
function Home() {
    const [updateTimes,setUpdateTimes] = useState<UpdateTimes>({
        yj01: '',
        yj02: '',
        yj03: '',
        yj04: ''
    })
    useEffect(() => {
        getUpdatetime().then(res=>{
            if(res.code === 0 && res.data){
                setUpdateTimes(res.data)
            }
        })
    }, [])
    function exportError(blob: Blob){
        const reader:FileReader  = new FileReader()
        reader.readAsText(blob, 'utf-8')
        reader.onload = function(){
            const res: Result =  JSON.parse(reader.result as string)
            if(res.code ===  ResultEnum.NOLOGIN || res.code === ResultEnum.OVERDUE){
                $message.error('登陆已过期，请重新登陆！')
            }else{
                $message.error(res.message)
            }}
    }
    function downLoad(fileName: string, blob: Blob){
        const link = document.createElement('a')
        link.download = fileName
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
    }
    function exportExcel(fileName: string, blob: Blob) {
        if(blob.type === 'application/json'){
            exportError(blob)
        }else{
            downLoad(fileName,blob)
        }
    }
    return (
        <div className='home'>
            <div className="container">
                <div className='item'>
                    <div className='img yj01'></div>
                    <div>今日预抵客人报表</div>
                    <div><button onClick={()=>{
                        exportYj01().then(res=>{
                            exportExcel('今日预抵客人报表.xlsx', res)
                        })
                    }} className='btn small'>下载</button></div>
                    {updateTimes.yj01&&<div>同步时间：{moment(updateTimes.yj01).format(LongDateFormat.YMDHMSIOS)}</div>}
                </div>
                <div className='item'>
                    <div className='img yj02'></div>
                    <div>当前在店客人余额报表 </div>
                    <div><button onClick={()=>{
                        exportYj02().then(res=>{
                            exportExcel('当前在店客人余额报表.xlsx', res)
                        })
                    }} className='btn small'>下载</button></div>
                    {updateTimes.yj02&& <div>同步时间：{moment(updateTimes.yj02).format(LongDateFormat.YMDHMSIOS)}</div>}
                </div>
                <div className='item'>
                    <div className='img yj03'></div>
                    <div>实时房态报表</div>
                    <div><button onClick={()=>{
                        exportYj03().then(res=>{
                            exportExcel( '实时房态报表.xlsx', res)
                        })
                    }} className='btn small'>下载</button></div>
                    {updateTimes.yj03&&<div>同步时间：{moment(updateTimes.yj03).format(LongDateFormat.YMDHMSIOS)}</div>}
                </div>
                <div className='item'>
                    <div className='img yj04'></div>
                    <div>临时挂账一览报表</div>
                    <div><button onClick={()=>{
                        exportYj04().then(res=>{
                            exportExcel('临时挂账一览报表.xlsx', res)
                        })
                    }} className='btn small'>下载</button></div>
                    {updateTimes.yj04&&<div>同步时间：{moment(updateTimes.yj04).format(LongDateFormat.YMDHMSIOS)}</div>}
                </div>
            </div>
        </div>
       
    )
}
export default Home
